import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { edit_profile_action } from "../ducks/user/actions";
import { requestHelper } from "../helpers/request-helper";
import { formatAndRaiseError } from "../helpers/general";

export default useEditProfile;

function editProfileApi({ first_name, last_name }) {
  return requestHelper(
    `
      mutation editProfile($firstName: String!, $lastName: String!) {
        proxyEditProfile(first_name: $firstName, last_name: $lastName) {
          first_name
          last_name
        }
      }
    `,
    {
      firstName: first_name,
      lastName: last_name,
    }
  )
    .then((data) => {
      return data.proxyEditProfile;
    })
    .catch(formatAndRaiseError);
}

function useEditProfile() {
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState();
  let dispatch = useDispatch();
  let editProfile = useCallback(function editProfile_memo({
    first_name,
    last_name,
  }) {
    setLoading(true);

    return editProfileApi({ first_name, last_name })
      .then(() => {
        dispatch(
          edit_profile_action({
            first_name,
            last_name,
          })
        );
      })
      .catch((error) => {
        setError(error);
      })

      .finally(() => setLoading(false));
  },
  []);

  return {
    editProfile,
    loading,
    error,
  };
}
